import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { LayoutService } from '../service/layout.service';

/** Rodapé do layout: exibe a versão atual da aplicação. */
@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        SICOM by
        <a href="https://portal.cfm.org.br/" target="_blank" rel="noopener noreferrer" class="text-primary font-bold ">Conselho Federal de Medicina</a>
        <p>Versão: {{ version() }}</p>
    </div>`
})
export class AppFooter {
    private readonly layoutService = inject(LayoutService);

    readonly version = computed(() => this.layoutService.layoutConfig().version ?? '0.0.0');
}
